import { numberWithCommas } from "../helpers/numberConverter";


const labelsMap = {
  he: {
    employeeSum: "חלק המבוטח",
    employerSum: "חלק המעסיק",
    compensationSum: "פיצויים",
  },

  ar: {
    employeeSum: "القسم المؤمن",
    employerSum: "قسم المشغل",
    compensationSum: "تعويضات",
  },
};

const getLabel = (lang, key) => {
  return labelsMap[lang][key];
};

export function generatePieData(pieData, lang = "he") {
  const currencySymbolHeb = lang == "he" ? "₪" : "";
  const currencySymbolArab = lang == "ar" ? "₪" : "";
  if (pieData) {
    return [
      {
        id: "חלק המבוטח",
        label: `${currencySymbolArab}`+`${getLabel(lang, "employeeSum")}:`+ `${currencySymbolHeb}` + `${numberWithCommas(
          Math.floor(pieData?.employeeSum)
        )}`,
        value: pieData?.employeeSum,
        color: "#0250C1",
      },
      {
        id: "חלק המעסיק",
        label: `${currencySymbolArab}`+`${getLabel(lang, "employerSum")}:`+ `${currencySymbolHeb}` + `${numberWithCommas(
          Math.floor(pieData?.employerSum)
        )}`,
        value: pieData?.employerSum,
        color: "#17CFFF",
      },
      {
        id: "פיצויים",
        label: `${currencySymbolArab}`+`${getLabel(lang, "compensationSum")}:`+ `${currencySymbolHeb}` + `${numberWithCommas(
          Math.floor(pieData?.compensationSum)
        )}`,
        value: pieData?.compensationSum,
        color: "#6C6C6D",
      },
    ];
  }
  return [];
}

export const legendsData = {
  anchor: "left",
  direction: "column",
  justify: false,
  translateX: -10,
  translateY: 7,
  itemsSpacing: 15,
  itemWidth: 150,
  itemHeight: 25,
  itemTextColor: "#000",
  itemDirection: "right-to-left",
  itemOpacity: 1,
  symbolSize: 12,
  symbolShape: "circle",
};

// with justify
// export const legendsData = {
//   anchor: "left",
//   direction: "column",
//   justify: true,
//   translateX: -50,
//   translateY: 7,
//   itemsSpacing: 15,
//   itemWidth: 180,
//   itemHeight: 25,
//   itemTextColor: "#000",
//   itemDirection: "right-to-left",
//   itemOpacity: 1,
//   symbolSize: 12,
//   symbolShape: "circle",
// };
